import { Link } from "react-router-dom";
import { works } from "@/mocks/works";
import WorkCard from "@/components/feature/WorkCard";

export default function FeaturedWorks() {
  const featured = works.slice(0, 6);

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="container-site">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <span className="text-xs font-semibold tracking-[0.25em] uppercase text-primary-700">
              Selected Works
            </span>
            <h2 className="font-heading font-extrabold text-2xl md:text-4xl text-foreground-950 mt-3">
              代表作品精选
            </h2>
          </div>
          <Link
            to="/works"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-700 hover:gap-3 transition-all whitespace-nowrap cursor-pointer"
          >
            查看全部作品
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          {featured.map((w) => (
            <WorkCard key={w.id} work={w} />
          ))}
        </div>
      </div>
    </section>
  );
}